import { combineReducers } from 'redux';
import { getLibraryReducers, ComponentEtaReduxState } from '@eta/components';

import { profileReducer, ProfileState } from '../../Profile/Redux/Reducer';
import {
    ReferenceDataState,
    referenceDataReducer,
} from '../../ReferenceData/Redux/Reducer';
import {
    InvitationState,
    invitationReducer,
} from '../../AcceptInvitation/Redux/Reducer';
import { VerifyReducer, VerifyState } from '../../Verification/Redux/Reducer';
import {
    TaxpayerProfileState,
    taxpayerReducer,
} from '../../TaxpayerProfile/Redux/Reducer';
import { reduxStateSampleReducer } from '../../sample/components/Redux/Reducer';
import { ReduxStateSampleState } from '../../sample/components/Redux/Types';
import { IntermediaryReducer, IntermediaryState } from '../../ProviderManagement/Redux/Reducer';

export interface ReduxState extends ComponentEtaReduxState {
    profile: ProfileState;
    taxpayerProfile: TaxpayerProfileState;
    Intermediary: IntermediaryState;
    invitation: InvitationState;
    referenceData: ReferenceDataState;
    Verify: VerifyState;
    reduxStateSample: ReduxStateSampleState;
}

export default combineReducers({
    ...getLibraryReducers(),
    profile: profileReducer,
    taxpayerProfile: taxpayerReducer,
    Intermediary: IntermediaryReducer,
    invitation: invitationReducer,
    referenceData: referenceDataReducer,
    Verify: VerifyReducer,
    reduxStateSample: reduxStateSampleReducer
});
